import MessagingRoutesBaseHandler from './base-handler.js';

export default class MessagingRoutesConversationDetailsHandler extends MessagingRoutesBaseHandler {
  get conversation() {
    return this.options?.parentHandler?.conversation;
  }

  get members() {
    return this.conversation?.users ?? [];
  }
}
